import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

const EntryFormDetailsContext = createContext();
EntryFormDetailsContext.displayName = "entryForm";

export const useEntryFormDetails = () => useContext(EntryFormDetailsContext);

export const EntryFormDetailsProvider = ({
  children,
  initialState,
  reducer,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <EntryFormDetailsContext.Provider value={[state, dispatch]}>
      {children}
    </EntryFormDetailsContext.Provider>
  );
};

EntryFormDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    entryFormDetails: PropTypes.object.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
